import _ from "lodash";
import { WSInstance } from "./axios_config";
import moment from "moment";

const COURSE_API_BASE_URL = `${process.env.API_URL}/courses`;
const CATALOG_API_BASE_URL = `${process.env.API_URL}/catalog`;

const findListOfAllCourses = async () => {
    return await WSInstance.get(`${COURSE_API_BASE_URL}/all`);
};

const saveCourse = async (course) => {
    if (course?.secondaryUniversities) {
        // {label, value} depuis le formulaire, {universityId} depuis la duplication
        course["secondaryUniversities"] = course.secondaryUniversities.map((item) => {
            return { universityId: item.value ?? item.universityId };
        });
    }
    return WSInstance.post(COURSE_API_BASE_URL, convertToUtc(course), {
        withCredentials: true,
    });
};

const deleteCourses = async (course) => {
    return WSInstance.post(`${COURSE_API_BASE_URL}/delete`, course, {
        withCredentials: true,
    });
};

const updateCourse = async (id, course) => {
    if (course?.secondaryUniversities) {
        course["secondaryUniversities"] = course.secondaryUniversities.map((item) => {
            return { universityId: item.value };
        });
    }
    return WSInstance.put(`${COURSE_API_BASE_URL}/${id}`, convertToUtc(course), {
        withCredentials: true,
    });
};

const getLabelKeyByGroupAndCode = (group, code) => {
    // get the label key in the language json file by group and code
    let labelId = "lov.";
    if (group) {
        labelId = labelId.concat(group.replace(/[-_]/g, ".").toLowerCase()).concat(".");
    }
    if (code) {
        labelId = labelId.concat(code.replace(/[-_]/g, ".").toLowerCase());
    }
    return labelId;
};

const approveCourse = async (id) => {
    return WSInstance.put(`${COURSE_API_BASE_URL}/approve/${id}`, {}, { withCredentials: true });
};

const disapproveCourse = async (id) => {
    return WSInstance.put(`${COURSE_API_BASE_URL}/disapprove/${id}`, {}, { withCredentials: true });
};

const searchByCriteria = async (formData, page, pageSize, orderModel) => {
    formData["sort"] = [];
    if (orderModel) {
        orderModel.forEach((element) => {
            formData["sort"].push(element.field + "," + element.sort);
        });
    }
    formData["page"] = page;
    formData["size"] = pageSize;

    if (formData["privateCourse"] && formData["privateCourse"].length === 2) {
        delete formData["privateCourse"];
    }

    if (formData["visible"] && formData["visible"].length === 2) {
        delete formData["visible"];
    }

    if (formData["approved"] && formData["approved"].length === 2) {
        delete formData["approved"];
    }

    if (formData["secondaryUniversities"]) {
        formData["secondaryUniversities"] = formData["secondaryUniversities"].map((university) => {
            return Number(university.value);
        });
    }
    return await WSInstance.get(COURSE_API_BASE_URL, { params: formData });
};

const searchCatalogByCriteria = async (formData, page, pageSize, sortModel) => {
    formData["sort"] = [];
    if (sortModel) {
        sortModel.forEach((element) => {
            formData["sort"].push(element.field + "," + element.sort);
        });
    }
    formData["page"] = page;
    formData["size"] = pageSize;

    if (formData["privateCourse"] && formData["privateCourse"].length === 2) {
        delete formData["privateCourse"];
    }

    if (formData["visible"] && formData["visible"].length === 2) {
        delete formData["visible"];
    }

    if (formData["approved"] && formData["approved"].length === 2) {
        delete formData["approved"];
    }

    if (formData["secondaryUniversities"]) {
        formData["secondaryUniversities"] = formData["secondaryUniversities"].map((university) => {
            return Number(university.value);
        });
    }
    return await WSInstance.get(CATALOG_API_BASE_URL, { params: formData });
};

const findCourseById = async (courseId) => {
    return await WSInstance.get(`${COURSE_API_BASE_URL}/${courseId}`);
};

const findCourseDetailsByCourseId = async (courseId) => {
    return await WSInstance.get(`${COURSE_API_BASE_URL}/public/${courseId}`);
};

const searchCourseStudents = async (courseId) => {
    return await WSInstance.get(`${COURSE_API_BASE_URL}/${courseId}/students`);
};

const convertToUtc = (course) => {
    const courseCopy = _.cloneDeep(course);
    if (courseCopy["sessions"]) {
        courseCopy["sessions"].forEach((session) => {
            if (session["startDate"]) {
                session["startDate"] = moment(session["startDate"]).utc().format();
            }
            if (session["endDate"]) {
                session["endDate"] = moment(session["endDate"]).utc().format();
            }
        });
    }
    return courseCopy;
};

const findTeacherByEmail = async (params) => {
    return await WSInstance.get(`${COURSE_API_BASE_URL}/teachers`, { params: params });
};

const findCoursesNotEnrolledByUserId = async (userId) => {
    return await WSInstance.get(`${COURSE_API_BASE_URL}/not-enrolled/${userId}`, { params: userId });
};

const findAllCoursesOrderByPeriod = async () => {
    return await WSInstance.get(`${COURSE_API_BASE_URL}/all-order-by-period`);
};

const findCourseResumeByCourseId = async (courseId) => {
    return await WSInstance.get(`${COURSE_API_BASE_URL}/${courseId}/resume`);
};

const editCourseEnrollment = async (courseId, userId, enrollmentRequestDto) => {
    return await WSInstance.put(`${COURSE_API_BASE_URL}/${courseId}/users/${userId}/enrollment`, enrollmentRequestDto, {
        headers: { "Content-Type": "application/json" },
    });
};

const editCourseCompletion = async (courseId, userId, completed) => {
    return await WSInstance.put(
        `${COURSE_API_BASE_URL}/${courseId}/users/${userId}/completion`,
        { completed: completed },
        { headers: { "Content-Type": "application/json" } }
    );
};

const changeCourseEnrollmentStatus = async (courseId, userId, enrlId, newStatus) => {
    return await WSInstance.put(
        `${COURSE_API_BASE_URL}/${courseId}/users/${userId}/enrollment/${enrlId}`,
        { enrollmentStatus: newStatus },
        { headers: { "Content-Type": "application/json" } }
    );
};

const courseService = {
    getLabelKeyByGroupAndCode,
    saveCourse,
    updateCourse,
    deleteCourses,
    approveCourse,
    disapproveCourse,
    searchCourseStudents,
    searchByCriteria,
    searchCatalogByCriteria,
    findTeacherByEmail,
    findCourseById,
    findCourseDetailsByCourseId,
    findListOfAllCourses,
    findAllCoursesOrderByPeriod,
    findCoursesNotEnrolledByUserId,
    findCourseResumeByCourseId,
    editCourseEnrollment,
    editCourseCompletion,
    changeCourseEnrollmentStatus,
};

export default courseService;
